import { Component, Input } from "@angular/core";

@Component({
    selector: "mobi-office-lib-table-skeleton",
    templateUrl: "./table-skeleton.component.html",
    styleUrl: "./table-skeleton.component.scss",
    standalone: false
})
export class TableSkeletonComponent {
  @Input() numberOfRows: number = 10;
  @Input() numberOfColumns: number = 5;

  @Input() isFullWidthHeader: boolean = false;
  @Input() isFullWidthBody: boolean = false;
  @Input() isFullWidthFooter: boolean = true;

  rows = Array(this.numberOfRows).fill(null);
  columns = Array(this.numberOfColumns).fill(null);
}
